/** Figma 시안 기준 너비 */
export const DESKTOP_WIDTH = 1920;
export const MOBILE_WIDTH = 390;

/** Figma header #421:6842 — 390×62 (padding 16/20 포함, logo 107×24, menu 30×30) */
export const MOBILE_HEADER_HEIGHT = 62;

/** Figma desktop header — padding(40+40) + logo(36) */
export const DESKTOP_HEADER_HEIGHT = 116;

/** 데스크톱 시안(1920px) 값 → vw */
export function toVw(px: number, base = DESKTOP_WIDTH): string {
  return `${(px / base) * 100}vw`;
}

/** 데스크톱 시안 값을 모바일 시안(390px) 기준 px로 환산 */
export function toMobilePx(px: number): string {
  const value = (px / DESKTOP_WIDTH) * MOBILE_WIDTH;
  return `${Math.round(value * 100) / 100}px`;
}

/**
 * 데스크톱 시안 값 → clamp(min, vw, max)
 * min: 390px 뷰포트 기준, max: 1920px 시안 원본
 */
export function toClamp(desktopPx: number): string {
  return `clamp(${toMobilePx(desktopPx)}, ${toVw(desktopPx)}, ${desktopPx}px)`;
}
